import Vue from 'vue'
import Vuex from 'vuex'
import basicMutations from './store/basicMutations'
import {BlankState, BlankDictionary} from './store/stateParts'
import nakdanActions from './store/nakdanActions'
import {accountModule, initializeFirebase} from 'shared/account'
import {dropboxModule} from 'shared/dropbox/store'
import {AppConfig} from '@/appConfig'

Vue.use(Vuex)

let storeObj = {
  state: JSON.parse(JSON.stringify(BlankState)),
  mutations: Object.assign({...basicMutations}),
  actions: Object.assign({...nakdanActions}),
}
let modulesObj = {
  account: accountModule
}
if (AppConfig.OFFER_DROPBOX) modulesObj['dropbox'] = dropboxModule
Vue.set(storeObj, 'modules', modulesObj)
const store = new Vuex.Store(storeObj)

initializeFirebase(store, {
  appPrefix: 'abbreviation',
  syncFields: ['permissionToUseData', 'dictionary'],
  modifyReceived: {
    dictionary: (firebaseDictionary) => {
      let dictionaryToStore = firebaseDictionary ? firebaseDictionary : {}
      Object.keys(BlankDictionary).forEach(k => {
        if (!(dictionaryToStore[k])) Vue.set(dictionaryToStore, k, {}) // Firebase "omits" empty-object fields
      })
      return dictionaryToStore
    }
  },
  sharedSyncFields: ['dropbox_token']
})

export default store
